import React from "react";
import { Provider } from "react-redux";
import { courtConnectContext, CourtConnectContext } from "./court-connect-context";
import { store } from "./store";
import Router from "./common/navigation/router";
import "./styles/styles.less";
import { ConfigProvider } from "antd";
import IdleTimer from "./IdleTimer";

const validateMessages = {
  required: "${label} is required.", // eslint-disable-line no-template-curly-in-string
  // eslint-disable-next-line no-template-curly-in-string
  whitespace: "${label} is required."
  // ...
};

const App = () => (
  <Provider store={store}>
    <CourtConnectContext.Provider value={courtConnectContext}>
      <ConfigProvider form={{ validateMessages }}>
        <Router />
      </ConfigProvider>
    </CourtConnectContext.Provider>
    <IdleTimer />
  </Provider>
);

export default App;
